import { h, FunctionComponent } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { Checkbox } from 'up-ops-web-shared-components';
import { CheckboxInputProps } from '../types/forms';

const CheckboxInput: FunctionComponent<CheckboxInputProps> = props => {
  const {
    id,
    label,
    checked,
    onChangeHandler,
    onBlurHandler,
    onFocusHandler,
    disabled,
    required,
    className = '',
    style = {},
  } = props;
  const inputRef = useRef<any>(null); // mismatch between HTMLInputElement and the shared component library's <Checkbox /> type

  useEffect(() => {
    if (inputRef.current !== null) {
      inputRef.current.checked = checked;
    }
  }, [checked]);

  const checkboxWrapperProps = {
    className,
    style,
  };

  return (
    <Checkbox
      id={`checkbox-${id}`}
      innerRef={inputRef}
      label={label}
      checked={checked}
      onChange={onChangeHandler}
      onBlur={onBlurHandler}
      onFocus={onFocusHandler}
      disabled={disabled}
      required={required}
      {...checkboxWrapperProps}
    />
  );
};

export default CheckboxInput;
